import {initTomSelectInput} from "../../helpers/inputs/tom-select/tom-select";
import {scrollToElement} from "../../helpers/scrolling/scrolling";
import {createReplaceableElement} from "../../helpers/replaceableElement";
import createElement from "../../helpers/createElement";
import {initFlatPickerInput} from "../../helpers/inputs/flatPicker/flatPicker";
import {fillInputsByName, getInputsByName} from "../../helpers/forms";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {formatDistance, subMinutes} from "date-fns";
import {parseHtmlDateTime} from "../../helpers/dates";
import {createModal} from "../../helpers/modal";
import {loading, stopLoading} from "../../helpers/loading";

function initViewComponentsExamples() {
	// Init all 'tom select' selects
	document.querySelectorAll('.tom-select-select').forEach(select => {
		initTomSelectInput(select);
	})

	// Init all 'flatpickr' inputs
	document.querySelectorAll('.flatpickr-inputs').forEach(input => {
		initFlatPickerInput(input)
	});
	document.querySelectorAll('.flatpickr-inputs-empty').forEach(input => {
		initFlatPickerInput(input, {
			defaultDate: null,
		})
	});
	document.querySelectorAll('.flatpickr-inputs-with-time').forEach(input => {
		initFlatPickerInput(input, {
			enableTime: true,
		})
	});
	document.querySelectorAll('.flatpickr-inputs-with-time-utc').forEach(input => {
		initFlatPickerInput(input, {
			enableTime: true,
		})
	});

	/**
	 * Init scrolling tests
	 */
	document.querySelector('.scroll-body-test-button').onclick = () => {
		const lastPTag = document.querySelector('.scroll-body-test .scroll-target');
		scrollToElement(lastPTag)
	}

	document.querySelector('.nested-scroll-test-button').onclick = () => {
		const lastPTag = document.querySelector('.nested-scroll-test .scroll-target');
		scrollToElement(lastPTag)
	}

	/**
	 * Init replaceable component
	 */
	const component = createReplaceableElement({
		element: document.querySelector('.replaceable-component-test'),
		init: function () {
			this.element
				.querySelector('.reload-button')
				.addEventListener('click', () => {
					const rawHtml = component.element.outerHTML;

					const newComponent = createElement(
						// Edit html so we know it was replaced
						rawHtml.replace(
							/REPLACED \d+ TIMES/,
							`REPLACED ${this.timesReplaced} TIMES`
						)
					);

					component.startLoading()
					setTimeout(() => {
						// Add fake delay
						component.replace(newComponent);
						component.timesReplaced++;
					}, 512)
				})
		},
		timesReplaced: 1,
	});

	// Can still get auto complete on extra properties
	console.log(component.timesReplaced)

	/**
	 * Setup replaceable collapsible card
	 */
	const collapsibleCard = createReplaceableElement({
		element: document.querySelector('.collapsable-card'),
		init() {
			// Reload button
			this.element.querySelector('.reload-collapsable-card-from-server-button').onclick = () => {
				collapsibleCard.startLoading();

				Axios.get(window['routes/development.view-components-examples.reload-collapsible-card'])
					.then(response => {
						// noinspection JSUnresolvedVariable
						const card = createElement(response.data.collapsibleCard)

						collapsibleCard.replace(card);
					})
					.catch(handleAjaxError)
					.finally(() => collapsibleCard.stopLoading())
			}
		}
	});

	/**
	 * Setup dates examples
	 */

	/**
	 * @type {Element}
	 */
	const serverDateInput = document.querySelector('.flatpickr-compare-dates-date-input-1');
	const dateFnsInput = document.querySelector('.flatpickr-compare-dates-date-input-2');

	/** @type {import('flatpickr/dist/types/instance').Instance} */
	const serverDateInputFlatpickrInstance = serverDateInput['_flatpickr'];
	/** @type {import('flatpickr/dist/types/instance').Instance} */
	const flatpickrInstance = dateFnsInput['_flatpickr'];

	// noinspection JSUnresolvedVariable
	flatpickrInstance.setDate(subMinutes(parseHtmlDateTime(dateFnsInput.dataset.time), 30))

	// Setup compare dates button
	document.querySelector('.flatpickr-set-compare-dates-button').onclick = () => {
		fillInputsByName(document.body, {
			'flatpickr_compare_dates_result': formatDistance(
				serverDateInputFlatpickrInstance.latestSelectedDateObj,
				flatpickrInstance.latestSelectedDateObj
			)
		})
	}

	/**
	 * Modals
	 */

	const clientModal = createModal({
		modalContainer: document.querySelector('.client-modal')
	})

	// Empty modal
	const serverModal = createModal({});

	const clientModalButton = document.querySelector('.display-client-modal-button');
	const serverModalButton = document.querySelector('.display-server-modal-button');


	clientModalButton.onclick = () => clientModal.display();
	serverModalButton.onclick = () => {
		// Load modal from server
		loading();

		Axios.get(window['routes/development.view-components-examples.server-modal'])
			.then(response => {
				const modal = createElement(response.data.modal);

				serverModal.replace(modal);

				serverModal.display();
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}


	/**
	 * Test forms.js functions
	 */
	const testFillInputsCard = document.querySelector('.text-fill-inputs-card');

	fillInputsByName(testFillInputsCard, {
		test_input_a: 'FILLED FROM JS - A',
		test_input_b: 'FILLED FROM JS - B',
		test_checkbox_a: true,
		test_radio_a: 'b',
	})

	// Read and fill text area
	const readAndFillInputs = () => {
		const inputsReadFromDom = getInputsByName(testFillInputsCard, [
			'test_input_a',
			'test_input_b',
			'test_checkbox_a',
			'test_radio_a',
		])


		fillInputsByName(testFillInputsCard, {
			test_input_c: JSON.stringify(inputsReadFromDom)
		})
	}

	readAndFillInputs()

	// Setup reload button
	document.querySelector('.reload-test-fills-textarea-button').onclick = readAndFillInputs
}

export {initViewComponentsExamples}
